import { Link, useNavigate } from 'react-router-dom';
import img1 from '../assets/images/pattern.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { useAuth } from '../Redux/hooks/useAuth';
import { useDispatch } from 'react-redux';
import { LoginRequest, useGetCaptchaQuery, useLoginMutation } from '../Redux/Apis/authApi';
import { setCredentials } from '../Redux/Slices/authSlice';
import MetaTags from '../Components/MetaTags';

function Login() {
    const navigate = useNavigate()
    const auth = useAuth()
    useEffect(() => {
        if (auth.user) navigate('/panel')
    })

    const dispatch = useDispatch()
    
    const [login, { isLoading }] = useLoginMutation()
    const [refresh, setRefresh ] = useState(1)
    const [errorMsg, setErrorMsg] = useState<any>(false)

    const { data } = useGetCaptchaQuery({refresh})
    const getCaptcha = () =>  {
        setRefresh((prev) => prev + 1)
    }

    const [formState, setFormState] = useState<LoginRequest>({
        email: '',
        password: '',
        captcha: '',
    })

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            const user = await login(formState).unwrap()
            dispatch(setCredentials(user))
            navigate('/panel')
            
        } catch (err:any){
            // console.log(err);
            getCaptcha();
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }


    return ( 
        <>
        <MetaTags
            siteName="سایت مرجع آزمون GRE"
            title="ورود به آزمون‌ها | سایت مرجع آزمون GRE"
            description="سایت GREhub شبیه ساز حرفه ای آزمون های بین المللی GRE با این هدف راه اندازی شده است که شما داوطلبان گرامی بتوانید سوالات واقعی آزمون GRE، مثل کراون Crown، دالائو Dalao و سایر سوالات اصلی را در محیط شبیه ساز آزمون به صورت آنلاین تمرین کنید، تا مدیریت زمان را به خوبی فراگرفته، و در نتیجه در سنتر و موقع آزمون اصلی بهترین نمره را به راحتی بدست آورید و سپس از دانشگاه های مورد نظرتان به آسانی پذیرش بگیرید."
            url="https://grehub.org/login"
            image="https://grehub.org/GREhub_LOGO.jpg"
            ogType="website"
            twitterCard="summary_large_image"
        />
        <div className="container-fluid position-relative p-0">
            <div className="row pt-lg-5 g-0">
                <div className="col-lg-6 object-fit-fill">
                    <img src={img1} className="img-fluid h-100" style={{objectFit: "cover"}} alt="login"/>
                </div>
                <div className="col-lg-6 p-5 mt-lg-5">
                    <div className='p-5'>
                        <h2 className='text-danger'>خوش برگشتیــد!</h2>
                        <p>برای ورود مجدد به سیستم اطلاعات کاربری خود را وارد نمایید. </p>
                        {errorMsg && <div className="alert alert-warning" role="alert">
                            {errorMsg}
                        </div>}
                        <form id="login-form" onSubmit={onSubmit}>
                            <div className="row g-3">
                                <div className="col-12 mb-3">
                                    <label htmlFor="email" className="form-label">ایمیل</label>
                                    <input type="email" value={formState.email} onChange={handleChange} name="email" id='email' className="form-control border-0 bg-light px-4" placeholder="آدرس ایمیل خود را وارد نمایید" style={{height: "55px",direction: "rtl"}}/>
                                </div>
                                <div className="col-12 mb-3">
                                    <label htmlFor="password" className="form-label">رمز عبور</label>
                                    <input type="password" value={formState.password} onChange={handleChange} name="password" id='password' className="form-control border-0 bg-light px-4" placeholder="پسورد خود را وارد نمایید" aria-describedby="reset" style={{height: "55px"}}/>
                                    <div id="reset" className="form-text text-secondary text-end"><Link className='text-danger' to="/reset-pass">رمز عبور خود را فراموش کردید؟</Link></div>
                                </div>
                                <div className="col-12 input-group mb-3">
                                    <input type="text" name="captcha" value={formState.captcha} id='your_captcha' aria-label="user captcha" aria-describedby="captcha" onChange={handleChange} className="form-control border-0 bg-light px-4" placeholder="کد داخل تصویر" maxLength={4} style={{height: "55px"}}/>
                                    <span className="input-group-text border-0" id="captcha" style={{height: "55px"}}>
                                        <div onClick={getCaptcha} className="text-center" dangerouslySetInnerHTML={{ __html: data?.data! }}></div>
                                    </span>
                                </div>
                                
                                <div className="col-12">
                                    <button disabled={isLoading} name="signin" id="signin" className="btn btn-danger w-100 py-3" type="submit">ورود</button>
                                </div>
                            </div>
                        </form>
                        <p className='text-center mt-5 py-1'>
                        <FontAwesomeIcon icon="user-plus" className='me-1'/>
                        حساب کاربری ندارید؟  
                        &nbsp;
                        <Link to="/signup" className='text-decoration-underline'>ازینجا ثبت نام کنید</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        </>
     );
}

export default Login;